<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('stockTransfer.are_you_sure_to_reject') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('stockTransfer.reason')
              }}</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.reason"
                  :class="{ 'is-invalid': errors.has('reason') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('reason')">
                  {{ errors.first('reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="ok"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['record'],
  name: 'reject-reason-form',
  data () {
    return {
      model: {
        stock_transfer_id: '',
        transfer_status_id: 3,
        reason: ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  created () {
    this.model.stock_transfer_id = this.record.stock_transfer_id
  },
  methods: {
    ok () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stock/stockTransfer/reject', this.model)
        .then(response => {
          return this.$store.dispatch('stock/stockTransfer/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          if (
            error.message ===
              'The current user not yet belong to any warehouses.' ||
            error.message === 'Transferred and recieved user must be defferent.'
          ) {
            this.$toasted.info(error.message)
          } else {
            this.$toasted.error(error.message)
          }
          this.errors = new Errors(error.errors)
          this.saving = false
        })
    }
  }
}
</script>
